import { NavLink, Outlet } from "react-router-dom";
import { publicWebCopyForLang, type PublicWebCopyKey } from "@/shared/i18n/public-web-copy";
import { useProductPreferences } from "@/shared/i18n/use-product-locale";
import { PageMeta } from "@/shared/seo/PageMeta";
import "./Settings.css";

const LINKS = [
  { to: "/app/settings", labelKey: "settings.overview", end: true },
  { to: "/app/settings/profile", labelKey: "settings.account" },
  { to: "/app/settings/preferences", labelKey: "settings.marketNews" },
  { to: "/app/settings/notifications", labelKey: "settings.briefing" },
  { to: "/app/settings/subscription", labelKey: "settings.subscription" },
  { to: "/app/settings/referrals", labelKey: "settings.rewards" },
  { to: "/app/settings/privacy", labelKey: "settings.privacy" },
  { to: "/app/settings/support", labelKey: "settings.advanced" },
] satisfies ReadonlyArray<{
  to: string;
  labelKey: PublicWebCopyKey;
  end?: boolean;
}>;

export function SettingsLayout() {
  const copy = publicWebCopyForLang(useProductPreferences().lang);

  return (
    <div className="settings-layout">
      <PageMeta title={copy("layout.settings")} noindex />
      <h1 className="settings-title app-secondary-page-title">{copy("layout.settings")}</h1>
      <nav className="settings-nav" aria-label={copy("settings.sections")}>
        {LINKS.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={"end" in l ? l.end : undefined}
            className={({ isActive }) =>
              `settings-nav-link${isActive ? " settings-nav-link--active" : ""}`
            }
          >
            {copy(l.labelKey)}
          </NavLink>
        ))}
      </nav>
      <div className="settings-panel">
        <Outlet />
      </div>
    </div>
  );
}
